export default __webpack_public_path__ + "static/media/login_phone.c4fa0a14.png";